import {
    cleanCommonParams,
    mapAttachmentParams,
} from './common';

const mapImportUsersHistoriesParams = (
    isCreate,
    {
        attachment,
        import_kind: importKind,
        ...params
    },
) => {
    const importFormatParams = {
        old_bio: {
            file_type: 'bio',
            new_import_flow: false,
        },
        new_bio: {
            file_type: 'bio',
            new_import_flow: true,
        },
        license: {
            file_type: 'license',
            new_import_flow: false,
        },
    };

    return new Promise((resolve) => {
        resolve({
            import_users_history: {
                ...cleanCommonParams(params),
                ...importFormatParams[importKind],
                ...mapAttachmentParams(isCreate, attachment),
            },
        });
    });
};

export { mapImportUsersHistoriesParams };
